/* Copyright (c) 2018 Scaper */

import { IConfig } from "firebaseui";
import * as React from "react";
import { FirebaseAuth } from "react-firebaseui";
import { IApi } from "../../api/api";

import "firebaseui/dist/firebaseui.css";

interface IProps {
    api: IApi;
}

export class SignIn extends React.PureComponent<IProps, {}> {
    private readonly UI_CONFIG: IConfig = {
        callbacks: {
            signInSuccessWithAuthResult: () => false,
        },
        signInFlow: "popup",
        signInOptions: [
            this.props.api.auth.GoogleAuthProvider.PROVIDER_ID,
        ],
        tosUrl: "/terms",
    };

    public render() {
        const { api } = this.props;
        return (
            <FirebaseAuth
                firebaseAuth={api.auth()}
                uiConfig={this.UI_CONFIG}
            />
        );
    }
}
